import { SHARE_STATE, SOCIAL_KEY } from '@src/constants/FJShareSocialConstant.ts';
import FJUserUtil from '@src/util/FJUserUtil';
import FJYoutubeAPI from '@src/core/network/FJYoutubeAPI.ts';
import FJLinkedinAPI from '@src/core/network/FJLinkedinAPI.ts';

class FJPublishTarget {
    public title: string = '';
    public description: string = '';
    public tags: string[] = [];
    public status: string = SHARE_STATE.SHARE_IDLE;
    public avatar: string = '';
    public titleChanged: boolean = false;
    public descriptionChanged: boolean = false;

    private _type: string = '';
    public isUploadAvatarToS3: boolean = false;
    public privacyState = 'public'; // youtube need this
    public isFindAvatar = false; // 已经查找了头像，但是用户没有上传头像

    constructor(props: { type: string }) {
        this._type = props.type;
    }

    get type() {
        return this._type;
    }

    public encode() {
        return {
            title: this.title,
            description: this.description,
            tags: this.tags,
            privacyState: this.privacyState,
        };
    }

    public decode(data: any) {
        this.title = data.title;
        this.description = data.description;
        this.tags = data.tags;
        this.privacyState = data.privacyState;
    }

    public async requestAvatar() {
        switch (this._type) {
            case SOCIAL_KEY.YOUTUBE: {
                const res: any = await FJYoutubeAPI.fetchYoutubeUserProfile(
                    FJUserUtil.getAccessTokenWithType(this._type),
                ).catch(e => {
                    console.log(e);
                });
                if (res) {
                    this.isFindAvatar = true;
                    this.avatar = res.avatar;
                }
                break;
            }
            case SOCIAL_KEY.LINKEDIN: {
                const res: any = await FJLinkedinAPI.fetchLinkedInUserProfile(
                    FJUserUtil.getAccessTokenWithType(this._type),
                ).catch(e => {
                    console.log(e);
                });
                console.log('res', res);
                if (res) {
                    this.isFindAvatar = true;
                    this.avatar = res.picture;
                }
                break;
            }
            default:
                break;
        }
        return this.avatar;
    }

    public clear() {
        this.title = '';
        this.description = '';
        this.tags = [];
        this.privacyState = 'public';
        this.status = SHARE_STATE.SHARE_IDLE;
        this.titleChanged = false;
        this.descriptionChanged = false;
    }
}

export default FJPublishTarget;
